<template>
  <woot-modal :show.sync="show" :on-close="onClose" size="medium">
    <div class="column content-box">
      <woot-modal-header :header-title="$t('CAMPAIGN_FLOW.MESSAGE.TITLE')" />
      <div class="card">
        <label>
          {{ $t('CAMPAIGN.ADD.FORM.INBOX.LABEL') }}
          <select v-model="selectedInboxId" @change="onChangeInbox($event)">
            <option v-for="item in inboxes" :key="item.name" :value="item.id">
              {{ item.name }}
            </option>
          </select>
        </label>

        <delay-input
          v-model="delaySelected"
          :label="$t('CAMPAIGN_FLOW.MESSAGE.FORM.DELAY.LABEL')"
          placeholder="2"
          :unit-labels="{
            minutes: $t('CAMPAIGN_FLOW.MESSAGE.FORM.DELAY.UNITS.MINUTES'),
            hours: $t('CAMPAIGN_FLOW.MESSAGE.FORM.DELAY.UNITS.HOURS'),
            days: $t('CAMPAIGN_FLOW.MESSAGE.FORM.DELAY.UNITS.DAYS'),
          }"
        />

        <woot-message-editor
          v-model="messageContent"
          :disabled="isWhatsappChannel"
          class="input--note"
          :placeholder="$t('CAMPAIGN_FLOW.MESSAGE.FORM.MESSAGE.LABEL')"
          :enable-suggestions="false"
        />

        <quotation-tags v-if="hasQuotation" />

        <whatsapp-templates
          v-if="isWhatsappChannel && selectedInboxId && !selectedWaTemplate"
          :inbox-id="selectedInboxId"
          :only-select="true"
          @on-select-template="toggleWaTemplate"
          @on-send="onSendWhatsAppReply"
        />

        <div class="footer">
          <woot-button
            :disabled="buttonDisabled"
            color-scheme="warning"
            :title="$t('NOTES.ADD.TITLE')"
            @click="onAdd"
          >
            {{ $t('NOTES.ADD.BUTTON') }}
          </woot-button>
        </div>
      </div>
    </div>
  </woot-modal>
</template>

<script>
import WootMessageEditor from 'dashboard/components/widgets/WootWriter/Editor';
import FileUpload from 'vue-upload-component';
import { ALLOWED_FILE_TYPES } from 'shared/constants/messages';
import WhatsappTemplates from '../../conversation/contact/WhatsappTemplates.vue';
import DelayInput from 'dashboard/components/widgets/DelayInput.vue';
import QuotationTags from './QuotationTags.vue';

export default {
  name: 'ModalMessage',
  components: {
    WootMessageEditor,
    FileUpload,
    WhatsappTemplates,
    DelayInput,
    QuotationTags,
  },
  props: {
    onClose: {
      type: Function,
      default: () => {},
    },
    show: {
      type: Boolean,
      default: false,
    },
    content: {
      type: String,
      default: '',
    },
    inboxId: {
      type: Number,
      default: null,
    },
    delay: {
      type: Number,
      default: 0,
    },
    hasQuotation: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageContent: this.content,
      selectedInboxId: this.inboxId,
      delaySelected: this.delay,
      file: null,
      isWhatsappChannel: false,
      selectedWaTemplate: null,
    };
  },

  computed: {
    inboxes() {
      const validInboxes = this.$store.getters['inboxes/getInboxes'].filter(
        inbox => {
          const inboxesTypes = [
            'Channel::Whatsapp',
            'Channel::Api',
            'Channel::TwilioSms',
          ];
          return inboxesTypes.includes(inbox.channel_type);
        }
      );
      return validInboxes;
    },
    buttonDisabled() {
      return !this.messageContent.trim() || !this.selectedInboxId;
    },
    allowedFileTypes() {
      return ALLOWED_FILE_TYPES;
    },
  },

  methods: {
    onUpload(target) {
      this.file = target.file;
    },
    onAdd() {
      this.$emit('add', {
        content: this.messageContent,
        inbox_id: this.selectedInboxId,
        delay: Number(this.delaySelected),
        template: this.selectedWaTemplate,
      });
    },

    async onChangeInbox() {
      this.isWhatsappChannel = this.inboxes.some(
        i =>
          i.id === this.selectedInboxId &&
          i.channel_type === 'Channel::Whatsapp'
      );
      if (!this.isWhatsappChannel) this.selectedWaTemplate = null;
    },

    toggleWaTemplate(val) {
      this.selectedWaTemplate = val;
      return undefined;
    },
    async onSendWhatsAppReply({ message, templateParams }) {
      this.messageContent = message;
      this.selectedWaTemplate = templateParams;
      return undefined;
    },

    onFileDelete() {
      this.file = null;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  padding: 5rem;
}
.input--note {
  &::v-deep .ProseMirror-menubar {
    padding: 0;
    margin-top: var(--space-minus-small);
  }

  &::v-deep .ProseMirror-woot-style {
    max-height: 36rem;
  }
}

.footer {
  display: flex;
  justify-content: flex-end;
  align-items: center !important;
  gap: 1rem;
  width: 100%;
}

.file-uploads {
  display: flex;
  align-items: center;
}

</style>
